












  /* eslint-disable no-console */

  import Vue from "vue";
  import { Component, Watch } from "vue-property-decorator";
  import Reference from "./Reference.vue"
  import {CatalogueMatchDTO} from "@/dtos/sqe-dtos";
  import _ from 'lodash';

@Component({
  components: {
    Reference
  }
})
export default class MatchCommit extends Vue {
  existingMatches = [] as Array<CatalogueMatchDTO | null>;
  suggestion: CatalogueMatchDTO | null = null

  async getMatches() {
    this.existingMatches = []

    if (this.$store.state.image_catalog_id && this.$store.state.col_id){
      const imMatches = await this.$com.sqeComms?.getV1CatalogueImagedObjectsImagedObjectIdTextFragments(this.$store.state.image_catalog_id)
      const tfMatches = await this.$com.sqeComms?.getV1CatalogueTextFragmentsTextFragmentIdImagedObjects(this.$store.state.col_id)
      this.existingMatches = _.uniqBy([...(imMatches ? imMatches.matches : []), ...(tfMatches ? tfMatches.matches : [])], 'matchId')
          .filter(x => x.imagedObjectId === this.$store.state.image_catalog_id && x.textFragmentId === this.$store.state.col_id)
      if (this.existingMatches.length === 0)
        this.existingMatches = [null]
      else
        this.suggestion = this.existingMatches[this.existingMatches.length - 1]

      console.info(this.existingMatches)
    }
  }

  addEmptyRef() {
    this.existingMatches.push(null)
  }

  @Watch("$store.state.col_id")
  textFragmentIdChanged(newVal: number, oldVal: number) {
    console.info(oldVal, newVal)
    if (newVal !== oldVal) {
      this.getMatches()
    }
  }

  @Watch("$store.state.image_catalog_id")
  imagedObjectIdChanged(newVal: string, oldVal: string) {
    if (newVal !== oldVal) {
      this.getMatches()
    }
  }
  @Watch("$store.state.requestMatchCommitReload")
  refreshMatchCalled(newVal: boolean, oldVal: boolean) {
    if (newVal !== oldVal && newVal === true) {
      this.getMatches()
      this.$store.commit('matchCommitReloadSet', false)
    }
  }
}
